<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<!-- <div class="layout-wrapper" [ngClass]="{'layout-compact':layoutCompact}" (click)="onLayoutClick()"> -->
<div class="layout-wrapper" [ngClass]="{'layout-compact':layoutCompact}">

    <div #layoutContainer class="layout-container" [ngClass]="{'menu-layout-static': !isOverlay(),
            'menu-layout-overlay': isOverlay(),
            'layout-menu-overlay-active': overlayMenuActive,
            'menu-layout-horizontal': isHorizontal(),
            'menu-layout-slim': isSlim(),
            'layout-menu-static-inactive': staticMenuDesktopInactive,
            'layout-menu-static-active': staticMenuMobileActive}">

        <app-topbar></app-topbar>
        <app-member-requests-island></app-member-requests-island>

        <div class="layout-menu" [ngClass]="{'layout-menu-dark':darkMenu}" (click)="onMenuClick($event)">
            <p-scrollPanel #scrollPanel [style]="{height: '100%'}">
                <app-inline-profile *ngIf="profileMode=='inline'&&!isHorizontal()"></app-inline-profile>
                <app-menu [reset]="resetMenu"></app-menu>
            </p-scrollPanel>
        </div>

        <div class="layout-main">
            <app-breadcrumb></app-breadcrumb>

            <div class="layout-content">
                <router-outlet></router-outlet>

                <app-footer></app-footer>
            </div>
        </div>

        <app-rightpanel></app-rightpanel>

        <div class="layout-mask"></div>
    </div>

</div>